/* Keep mobile chat in the visible viewport when Safari opens its keyboard. */
(() => {
  'use strict';
  if (window.__ppaChatViewportReady) return;
  window.__ppaChatViewportReady = true;
  const mobile = matchMedia('(max-width: 700px)');
  const viewport = window.visualViewport;
  const style = document.documentElement.style;
  let frame = 0;
  const properties = ['--ppa-chat-height', '--ppa-chat-top', '--ppa-chat-width', '--ppa-chat-left'];
  function update() {
    frame = 0;
    if (!mobile.matches) {
      properties.forEach(name => style.removeProperty(name));
      return;
    }
    // Preserve pinch zoom rather than resizing the chat to a magnified viewport.
    const visible = viewport && viewport.scale === 1 ? viewport : null;
    const values = [visible?.height || innerHeight, visible?.offsetTop || 0,
      visible?.width || document.documentElement.clientWidth, visible?.offsetLeft || 0];
    properties.forEach((name, index) => {
      const value = `${values[index]}px`;
      if (style.getPropertyValue(name) !== value) style.setProperty(name, value);
    });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  viewport?.addEventListener('resize', schedule, { passive: true });
  viewport?.addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  mobile.addEventListener('change', schedule);
  update();
})();
